"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoadingMask = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _constants = require("../../constants");
var _customPropTypes = _interopRequireDefault(require("../../util/custom-prop-types"));
var _LoadingMaskContent = require("../LoadingMaskContent/LoadingMaskContent");
var _LoadingMaskSpinner = require("../LoadingMaskSpinner/LoadingMaskSpinner");
var _Spinner = require("../Spinner/Spinner");
var _VisuallyHidden = require("../VisuallyHidden/VisuallyHidden");
var _LoadingMask = require("./LoadingMask.styles");
var _excluded = ["children", "loading", "loadingVoiceOver", "iconSize"];
/**
 * A container used for masking content while something is loading, submitting, processing, etc.
 *
 * The container uses an ARIA live region with the
 * [status role](https://www.w3.org/TR/wai-aria-1.1/#status). When `loading` is set to `true`, the
 * content will be masked visually and hidden from screen readers, and the `loadingVoiceOver` text
 * will be announced.
 *
 * @related ['LoadingButton']
 * @since 8.1.0
 */
var LoadingMask = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, forwardedRef) {
  var children = _ref.children,
    loading = _ref.loading,
    loadingVoiceOver = _ref.loadingVoiceOver,
    iconSize = _ref.iconSize,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_LoadingMask.StyledLoadingMask, (0, _extends2.default)({
    ref: forwardedRef
  }, rest), loading ? /*#__PURE__*/_react.default.createElement(_VisuallyHidden.VisuallyHidden, null, loadingVoiceOver) : null, /*#__PURE__*/_react.default.createElement(_LoadingMaskContent.LoadingMaskContent, {
    loading: loading,
    "aria-hidden": loading
  }, children), /*#__PURE__*/_react.default.createElement(_LoadingMaskSpinner.LoadingMaskSpinner, {
    loading: loading,
    iconSize: iconSize
  }, /*#__PURE__*/_react.default.createElement(_Spinner.Spinner, null)));
});
exports.LoadingMask = LoadingMask;
LoadingMask.displayName = 'LoadingMask';
LoadingMask.propTypes = {
  /**
   * The content to be masked.
   */
  children: _propTypes.default.node.isRequired,
  /**
   * Loading mask's wrapper CSS display value
   */
  display: _customPropTypes.default.inlineMediaQuery(_propTypes.default.string),
  /**
   * The loading state of the container.
   */
  loading: _propTypes.default.bool,
  /**
   * The text that will be announced to screen readers using `VisuallyHidden`.
   */
  loadingVoiceOver: _propTypes.default.string,
  /**
   * The size of the `Spinner`.
   */
  iconSize: _propTypes.default.oneOf(Object.values(_constants.ICON_SIZES)),
  /**
   * The ARIA role, defaulting to [status](https://www.w3.org/TR/wai-aria-1.1/#status).
   */
  role: _propTypes.default.string
};
LoadingMask.defaultProps = {
  loading: true,
  loadingVoiceOver: 'Loading',
  iconSize: 'md',
  role: 'status',
  display: 'inline-flex'
};